import { InferType, object, string } from 'yup';
import i18n from '@components/i18n';

export const formValuesSchema = object().shape({
  name: string().default('').required(i18n.t('validation:required')),
  policyNumber: string().default('').required(i18n.t('validation:required')),
});

export type FormValues = InferType<typeof formValuesSchema>;
